'use strict';

module.exports = require('react/lib/ReactDOMServer');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/server.js
// module id = 67
// module chunks = 0